import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PageTitle } from '@common/page-layout/page-title';
import { PluginsAuditLogsBody } from './plugins-audit-logs-body';
export function PluginsAuditLogsPage() {
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "Change History", breadcrumbs: [{ title: 'Plugins', href: '/plugins' }] }), _jsx(PluginsAuditLogsBody, {})] }));
}
